
<v-dialog
    v-model = "value"
    max-width="1200"
    persistent

>
    <v-card>
        <v-card-title class="headline primary white--text" >
            <div>
                Gewährleistungen
            </div>
            <v-spacer />
            <inc-warranty-filter v-model="filter" />


        </v-card-title>
        <v-card-text class="pt-0 pl-3 pr-3 pb-0">
            <v-tabs
                v-model="tab"
                class="mt-2 folder-tabs"
                active-class="folder-tab-active primary"
                show-arrows
                height="30"
                style="margin-left: 0; padding: 0"
            >
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab
                    v-for="(unit, index) in warrenties" :key="index"
                    class="folder-tab"
                >
                    {{ unit.unit.fabricNo }}
                </v-tab>

                <v-tabs-items v-model="tab">
                    <v-tab-item
                        v-for="(unit, index) in warrenties" :key="index"
                    >
                        <inc-warranty-incident-site
                            :site="unit"
                            :component="component"
                            class="lm-border pa-3 pr-1"
                            @close="onCancel"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-card-text>
        <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn
                class="dialog-button mr-2"
                @click="onCancel"
                depressed
            >
                Schliessen
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
